<div class="aig-notfound">
  <aig-banner [info]="bannerInfo"></aig-banner>
  <div class="o-container">
    <div class="row u-justify-center">
      <div class="col-12 col-sm-12 col-lg-6 col-xl-6">
        <aig-textblock [config]="getCurrentStatus()"></aig-textblock>
      </div>
    </div>
  </div>
</div>
